import React from 'react';
import { Skeleton } from '@heroui/react';
import { Widget } from '@heroui-pro/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

/**
 * Placeholder mirroring the dictionary toolbar + table layout so the page
 * doesn't shift when the real data swaps in.
 */
export const AttributesPageSkeleton: React.FC = () => {
    return (
        <section
            aria-busy
            {...getNodeTestIdProp('attribute-dictionary-loading')}
        >
            <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <Skeleton className="h-10 w-48 rounded-xl" />
                <Skeleton className="h-10 w-full rounded-xl sm:w-80" />
            </div>
            <Widget
                className="flex flex-col gap-0 overflow-hidden p-0"
                {...getNodeTestIdProp('attribute-dictionary-loading-widget')}
            >
                <div className="flex flex-col gap-3 p-4">
                    {Array.from({ length: 6 }).map((_, index) => (
                        <div
                            className="flex items-center gap-4"
                            key={`attribute-dictionary-loading-row-${index}`}
                        >
                            <Skeleton className="h-4 flex-1 rounded-md" />
                            <Skeleton className="h-4 w-24 rounded-md" />
                            <Skeleton className="h-4 w-16 rounded-md" />
                            <Skeleton className="h-4 w-12 rounded-md" />
                        </div>
                    ))}
                </div>
            </Widget>
        </section>
    );
};
